import { render, staticRenderFns } from "./TableUnitStatusContent.vue?vue&type=template&id=ab90e9ea&scoped=true&"
import script from "./TableUnitStatusContent.vue?vue&type=script&lang=js&"
export * from "./TableUnitStatusContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab90e9ea",
  null
  
)

export default component.exports